import { InjectionToken } from "@angular/core";
import { OrganizationReferencePort } from "./organization-reference.port";

export const ORGANIZATION_REFERENCE_PORT =
  new InjectionToken<OrganizationReferencePort>("ORGANIZATION_REFERENCE_PORT");
